<template>
  <div class="results-pdf">
    <div class="results-pdf__subheader width-responsiveness">
      <h2>Laudos em PDF</h2>
      <div
        class="results-pdf__print-config"
        @click="openResultsPDFConfigModal"
      >
        <svg-loader src="/static/images/config.svg" />
        <span>Configurações de Impressão</span>
      </div>
    </div>
    <div class="width-responsiveness paternity-alert-container">
      <Alert
        alert-text="<strong>ATENÇÃO:</strong> Agora seus laudos de <strong>PATERNIDADE</strong> também estão disponíveis para download aqui no AOL.<br><strong>Importante:</strong> apenas os perfis SUPER ADM, ADM e PATERNIDADE tem acesso para baixa-los"
        item-name-in-storage="paternity-results-alert"
        icon="icon-alert.svg"
        feature-toggle="paternity"
      />
    </div>
    <ResultsPDFFilter />
    <ResultsPDFList
      v-if="resultsPdfList"
      :results-p-d-f-list="resultsPdfList"
    />
    <ResultsPDFAppendHTML />
    <AllResultsPDFInHTML />
    <div
      v-if="resultsPdfDownloadLoading"
      class="overlay-loading"
    >
      <Spinner />
    </div>
    <ResultsPDFConfigModal ref="resultsPDFConfigModal" />
  </div>
</template>

<script>
import Dropdown from '../common/Dropdown'
import ResultsPDFList from '@/components/ResultsPDF/ResultsPDFList'
import ResultsPDFFilter from '@/components/ResultsPDF/ResultsPDFFilter'
import ResultsPDFAppendHTML from '@/components/ResultsPDF/ResultsPDFAppendHTML'
import AllResultsPDFInHTML from '@/components/ResultsPDF/AllResultsPDFInHTML'
import ResultsPDFConfigModal from '@/components/ResultsPDF/ResultsPDFConfigModal'
import Spinner from '@/components/common/Spinner'
import Alert from '@/components/common/Alert'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ResultsPdfMainView',
  components: {
    ResultsPDFList,
    Dropdown,
    ResultsPDFFilter,
    ResultsPDFAppendHTML,
    AllResultsPDFInHTML,
    Spinner,
    ResultsPDFConfigModal,
    Alert,
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['resultsPdfList', 'listPDFForDownload', 'resultsPdfDownloadLoading']),
  },
  mounted() {
    this.getServiceResultsPDF()
    this.getPrintConfig()
  },
  methods: {
    ...mapActions(['getServiceResultsPDF', 'exportAllResultsInPDF', 'getPrintConfig']),
    combinePDFs(pdfArray) {
      return pdfArray.map(pdfBytes => new Uint8Array(pdfBytes))
    },
    openResultsPDFConfigModal() {
      this.$refs.resultsPDFConfigModal.openModal()
    },
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';
@import '../../../static/stylesheets/components/orders/empty-cart';

.results-pdf {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  font-family: 'Exo 2', sans-serif !important;

  &__subheader {
    display: flex;
    justify-content: space-between;
    align-content: center;
    z-index: 1;

    h2 {
      font-size: 22px;
      font-weight: 600;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 30px;
    }
  }

  &__print-config {
    display: flex;
    align-items: center;
    font-weight: 500;
    color: #7a7a7a;
    cursor: pointer;

    .md-icon {
      margin: 0;
      margin-right: 4px;
      width: 28px;
      height: 28px;

      path {
        fill: #7a7a7a;
      }
    }
  }

  .overlay-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #000000ad;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .loader {
      border-top: 1.1em solid rgba(255, 255, 255, 0.2);
      border-right: 1.1em solid rgba(255, 255, 255, 0.2);
      border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
      border-left: 1.1em solid #ffffff;
    }
  }

  .paternity-alert-container {
    .warning-alert {
      margin-bottom: 0;
    }
  }
}
</style>
